
import apiClient from './api';
export const getIssuersSummary = async (domainId, filters = {}, signal = null) => {
  try {
    const params = {
      DomainId: domainId,
      PageNumber: filters.pageNumber || 1,
      PageSize: filters.pageSize || 10,
      IssuerName: filters.issuerName || '',
      SortBy: filters.sortBy || 'IssuerName',
      SortDescending: filters.sortDescending || false,
      ...filters
    };

    // Nettoyer les paramètres vides
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    const config = { params };
    if (signal) {
      config.signal = signal;
    }

    const response = await apiClient.get('/api/Security/issuers/summary', config);
    
    if (response.data.success) {
      return response.data;
    }
    
    // Format de réponse cohérent même si l'API retourne une structure différente
    return {
      success: true,
      data: response.data.data || response.data.items || [],
      pagination: response.data.pagination || {
        totalCount: 0,
        pageSize: 10,
        pageNumber: 1,
        totalPages: 0,
        hasPreviousPage: false,
        hasNextPage: false
      },
      filters: response.data.filters || {}
    };
  } catch (error) {
    if (error.name === 'CanceledError' || error.name === 'AbortError') {
      throw new Error('SearchCancelled');
    }
    
    if (error.response?.status === 404) {
      return {
        success: true,
        data: [],
        pagination: {
          totalCount: 0,
          pageSize: 10,
          pageNumber: 1,
          totalPages: 0,
          hasPreviousPage: false,
          hasNextPage: false
        },
        filters: {}
      };
    }
    
    if (error.response?.status === 400) {
      const errorMessage = error.response.data?.message || 'Paramètres invalides';
      throw new Error(errorMessage);
    }
    
    // console.error("Erreur lors de la récupération des émetteurs :", error);
    throw error("Erreur lors de la récupération des émetteurs :", error);
  }
};